"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToJSON = void 0;
/** Converts an object to its JSON representation, including getters. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var convertToJSON = function (obj) {
    var jsonObj = __assign({}, obj);
    // Remove pseudo "protected"/"private" properties from object.
    Object.entries(jsonObj).forEach(function (_a) {
        var key = _a[0];
        if (key[0] === '_') {
            delete jsonObj[key];
        }
    });
    var proto = Object.getPrototypeOf(obj);
    // Assign any public getters to object. Ignore pseudo "protected"/"private" getters.
    Object.entries(Object.getOwnPropertyDescriptors(proto))
        .filter(function (_a) {
        var descriptor = _a[1];
        return typeof descriptor.get === 'function';
    })
        .forEach(function (_a) {
        var key = _a[0], descriptor = _a[1];
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (descriptor && key[0] !== '_') {
            try {
                jsonObj[key] = obj[key];
            }
            catch (error) {
                console.error("Error calling property ".concat(key), error);
            }
        }
    });
    return jsonObj;
};
exports.convertToJSON = convertToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFBQSx3RUFBd0U7QUFDeEUsOERBQThEO0FBQ3ZELElBQU0sYUFBYSxHQUFHLFVBQUMsR0FBd0I7SUFDcEQsSUFBTSxPQUFPLGdCQUFRLEdBQUcsQ0FBRSxDQUFDO0lBRTNCLDhEQUE4RDtJQUM5RCxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFDLEVBQUs7WUFBSixHQUFHLFFBQUE7UUFDbkMsSUFBSSxHQUFHLENBQUMsQ0FBQyxDQUFDLEtBQUssR0FBRyxFQUFFLENBQUM7WUFDbkIsT0FBTyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDdEIsQ0FBQztJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUV6QyxvRkFBb0Y7SUFDcEYsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMseUJBQXlCLENBQUMsS0FBSyxDQUFDLENBQUM7U0FDcEQsTUFBTSxDQUFDLFVBQUMsRUFBYztZQUFYLFVBQVUsUUFBQTtRQUFNLE9BQUEsT0FBTyxVQUFVLENBQUMsR0FBRyxLQUFLLFVBQVU7SUFBcEMsQ0FBb0MsQ0FBQztTQUNoRSxPQUFPLENBQUMsVUFBQyxFQUFpQjtZQUFoQixHQUFHLFFBQUEsRUFBRSxVQUFVLFFBQUE7UUFDeEIsdUVBQXVFO1FBQ3ZFLElBQUksVUFBVSxJQUFJLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxHQUFHLEVBQUUsQ0FBQztZQUNqQyxJQUFJLENBQUM7Z0JBQ0gsT0FBTyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztZQUMxQixDQUFDO1lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztnQkFDZixPQUFPLENBQUMsS0FBSyxDQUFDLGlDQUEwQixHQUFHLENBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztZQUN4RCxDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUwsT0FBTyxPQUFPLENBQUM7QUFDakIsQ0FBQyxDQUFDO0FBM0JXLFFBQUEsYUFBYSxpQkEyQnhCIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/url-catalog/src/utils.js
// module id = 3225
// module chunks = 25